import { Reveal, MaskLines, Eyebrow } from "./Motion";
import { CTAButton } from "./CTAButton";
import { SITE } from "../../content/site";

export const CTABand = ({
  eyebrow = "Start a conversation",
  title = ["Discuss your energy", "requirements with us."],
  text = "Share a few details about your facility and consumption. We will help you understand which solar options are worth evaluating.",
}) => (
  <section className="relative overflow-hidden bg-[#74DC26] text-[#082619]" data-testid="cta-band">
    <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-20 md:px-10 md:py-28 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-8">
        <Eyebrow className="!text-[#082619]">{eyebrow}</Eyebrow>
        <h2 className="font-display mt-6 text-4xl sm:text-5xl lg:text-7xl font-medium leading-[0.98] tracking-tight">
          <MaskLines lines={title} inView />
        </h2>
      </div>
      <Reveal className="lg:col-span-4" delay={0.2}>
        <p className="text-base leading-relaxed text-[#082619]/85">{text}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <CTAButton to="/contact" variant="forest" testId="cta-band-enquire">Enquire Now</CTAButton>
          <CTAButton href={SITE.phoneHref} variant="ghostDark" testId="cta-band-call">Call {SITE.phone}</CTAButton>
        </div>
      </Reveal>
    </div>
  </section>
);
